import { DownloadHistoryStatus } from '@numeo/types-main-web-app'
import axios from 'axios'

export interface DownloadHistoryEntry {
    downloadId: string
    filename: string
    status: DownloadHistoryStatus
    error?: string
    completedAt: string
    url?: string
    fileUrls?: string[]
}

export const downloadHistoryApi = {
    async getAll(): Promise<DownloadHistoryEntry[]> {
        const res = await axios.get<{ success: boolean; data: DownloadHistoryEntry[] }>('/download-history')
        return res.data.data ?? []
    },

    async upsert(entry: DownloadHistoryEntry): Promise<void> {
        await axios.put(`/download-history/${encodeURIComponent(entry.downloadId)}`, entry)
    },

    async clearAll(): Promise<void> {
        await axios.delete('/download-history')
    },
}
